import React, { useState } from 'react';
import { gallery } from '../data/mock';
import { X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Photos = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const { t, language } = useLanguage();
  
  // Get categories with translations
  const categoryMap = {
    'All': t('all'),
    'Competition': t('competition'),
    'Training': t('training')
  };
  
  const categories = ['All', ...new Set(gallery.map((item) => item.category))];

  const filteredGallery =
    selectedCategory === 'All'
      ? gallery
      : gallery.filter((item) => item.category === selectedCategory);

  return (
    <div className="min-h-screen bg-black">
      {/* Hero Section with B&W background, color subject */}
      <section
        className="relative h-96 flex items-center justify-center overflow-hidden"
      >
        {/* B&W Background Layer */}
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: 'url(https://customer-assets.emergentagent.com/job_b6c20734-bb90-4750-94f8-baaefceffec0/artifacts/r2hwbo6c_129DE1DF-38B9-4AA1-99EA-5448C1562DD5.jpeg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            filter: 'grayscale(100%)'
          }}
        ></div>
        {/* Color Subject Overlay */}
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: 'url(https://customer-assets.emergentagent.com/job_b6c20734-bb90-4750-94f8-baaefceffec0/artifacts/r2hwbo6c_129DE1DF-38B9-4AA1-99EA-5448C1562DD5.jpeg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            maskImage: 'radial-gradient(ellipse 50% 60% at 55% 50%, black 20%, transparent 60%)',
            WebkitMaskImage: 'radial-gradient(ellipse 50% 60% at 55% 50%, black 20%, transparent 60%)'
          }}
        ></div>
        <div className="absolute inset-0 bg-black/30"></div>
        {/* Vignette Effect */}
        <div 
          className="absolute inset-0"
          style={{
            background: 'radial-gradient(ellipse at center, transparent 0%, rgba(0,0,0,0.3) 30%, rgba(0,0,0,0.8) 70%, rgba(0,0,0,0.95) 100%)'
          }}
        ></div>
        <div className="relative z-10 text-center text-white px-4 pt-16">
          <h1 className="text-5xl md:text-6xl font-black mb-4">{t('photoGallery').split(' ')[0]} <span className="text-cyan-400">{t('photoGallery').split(' ').slice(1).join(' ') || 'Gallery'}</span></h1>
          <p className="text-xl md:text-2xl font-light text-zinc-300">{t('momentsFromArena')}</p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 bg-zinc-900 border-b border-zinc-800">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2 rounded-full font-medium transition-all duration-300 ${
                  selectedCategory === category
                    ? 'bg-cyan-500 text-white'
                    : 'bg-zinc-800 text-zinc-300 hover:bg-zinc-700'
                }`}
              >
                {categoryMap[category] || category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20 bg-zinc-950">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredGallery.map((item) => (
              <div
                key={item.id}
                onClick={() => setSelectedImage(item)}
                className="group relative aspect-square overflow-hidden rounded-lg shadow-md cursor-pointer hover:shadow-xl transition-all duration-300"
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                    <h3 className="font-bold text-lg">{item.title}</h3>
                    <p className="text-sm text-gray-300">{item.date}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
            onClick={() => setSelectedImage(null)}
          >
            <X className="w-8 h-8" />
          </button>
          <div className="max-w-6xl max-h-[90vh] flex flex-col items-center">
            <img
              src={selectedImage.image}
              alt={selectedImage.title}
              className="max-w-full max-h-[80vh] object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
            <div className="mt-6 text-center text-white">
              <h3 className="text-2xl font-bold mb-2">{selectedImage.title}</h3>
              <p className="text-gray-300">{selectedImage.date}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Photos;